module.exports = __webpack_public_path__ + "img/product5.86c11e86.jpg";